// Diagnose Mode: Standalone (Mode 1), VDR-invoked (Mode 2), and VDR multi-session (Mode 3). Root route table.
import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AdminStore } from './core/admin-features/store/admin.store';
import { canDeactivateWorkflowGuard } from './core/common/models/general.model';

import { UserProfileEffects } from './core/store/workflow/effects/user-profile.effects';
import { WorkflowEffects } from './core/store/workflow/effects/workflow.effects';
import {
  userProfileReducer,
  UserProfileState,
} from './core/store/workflow/reducers/user-profile.reducers';
import {
  workflowReducer,
  WorkflowState,
} from './core/store/workflow/reducers/workflow.reducers';
import { ADMIN_ROUTES } from './views/admin-features/admin.routes';
import { AdminLayoutComponent } from './views/layouts/admin-layout/admin-layout.component';
import { UserLayoutComponent } from './views/layouts/user-layout/user-layout.component';
import { WorkflowLayoutComponent } from './views/layouts/workflow-layout/workflow-layout.component';
import { SelectChallengesContainerComponent } from './views/select-challenge/components/select-challenges-container/select-challenges-container.component';
import { SelectSolutionsContainerComponent } from './views/select-solutions/components/select-solutions-container/select-solutions-container.component';
import { DiagnosisSummaryViewContainerComponent } from './views/view-summary/components/diagnosis-summary-view-container/diagnosis-summary-view-container.component';
import { WORKFLOW_ROUTES } from './views/workflow-v2/workflow.routes';

export const oldRoutes: Routes = [
  {
    path: 'user',
    component: UserLayoutComponent,
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateWorkflowGuard],
    children: [
      { path: '', redirectTo: '/select-challenges', pathMatch: 'full' },
      {
        path: 'eid/:eid',
        component: SelectChallengesContainerComponent,
      },
      {
        path: 'sid/:sid',
        component: SelectChallengesContainerComponent,
      },
      {
        path: 'select-challenges',
        component: SelectChallengesContainerComponent,
      },
      {
        path: 'select-solutions/:sid',
        component: SelectSolutionsContainerComponent,
      },
      {
        path: 'view-summary/:sid',
        component: DiagnosisSummaryViewContainerComponent,
      },
    ],
  },
];

export const routes: Routes = [
  {
    path: '',
    component: WorkflowLayoutComponent,
    providers: [
      provideState<WorkflowState>({
        name: 'workflow',
        reducer: workflowReducer,
      }),
      provideState<UserProfileState>({
        name: 'userProfile',
        reducer: userProfileReducer,
      }),
      provideEffects(WorkflowEffects, UserProfileEffects),
    ],
    children: WORKFLOW_ROUTES,
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateWorkflowGuard],
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    providers: [AdminStore],
    children: ADMIN_ROUTES,
    canActivate: [MsalGuard],
  },
];
